var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 200 200",
      "aria-hidden": "true"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "100",
      "cy": "100",
      "r": "88",
      "fill": "#EAF1FD"
    }
  }), _c('circle', {
    attrs: {
      "cx": "100",
      "cy": "100",
      "r": "68",
      "fill": "#D6E4FA",
      "opacity": "0.65"
    }
  }), _c('rect', {
    attrs: {
      "x": "58",
      "y": "52",
      "width": "72",
      "height": "96",
      "rx": "8",
      "fill": "#FFFFFF",
      "stroke": "#CBD5E1",
      "stroke-width": "2"
    }
  }), _c('rect', {
    attrs: {
      "x": "68",
      "y": "68",
      "width": "40",
      "height": "6",
      "rx": "3",
      "fill": "#E2E8F0"
    }
  }), _c('rect', {
    attrs: {
      "x": "68",
      "y": "82",
      "width": "52",
      "height": "6",
      "rx": "3",
      "fill": "#E2E8F0"
    }
  }), _c('rect', {
    attrs: {
      "x": "68",
      "y": "96",
      "width": "46",
      "height": "6",
      "rx": "3",
      "fill": "#E2E8F0"
    }
  }), _c('rect', {
    attrs: {
      "x": "68",
      "y": "110",
      "width": "36",
      "height": "6",
      "rx": "3",
      "fill": "#E2E8F0"
    }
  }), _c('circle', {
    attrs: {
      "cx": "132",
      "cy": "132",
      "r": "28",
      "fill": "#316BD6"
    }
  }), _c('path', {
    attrs: {
      "d": "M120 132l8 8 16-18",
      "fill": "none",
      "stroke": "#FFFFFF",
      "stroke-width": "5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('circle', {
    attrs: {
      "cx": "44",
      "cy": "56",
      "r": "5",
      "fill": "#34D399",
      "opacity": "0.85"
    }
  }), _c('circle', {
    attrs: {
      "cx": "156",
      "cy": "48",
      "r": "4",
      "fill": "#316BD6",
      "opacity": "0.45"
    }
  }), _c('circle', {
    attrs: {
      "cx": "48",
      "cy": "148",
      "r": "4",
      "fill": "#316BD6",
      "opacity": "0.35"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }